import src from "IMAGE";
export default { src, width: 414, height: 414, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAJ0lEQVR42rXOoQ0AAAjEwN9/4i8GEgZAEBB1JyqInNItsOn24GeyAEsB+rVJhKTTAAAAAElFTkSuQmCC"};
